export default "__VITE_ASSET__DzgglwrJ__"